<template>
  <div
    style="display: flex; align-items: center"
    :class="
      justifyB
        ? 'flex items-center justify-between'
        : justifyC
        ? 'flex justify-center items-center flex-col w-full'
        : justifyD
        ? 'flex justify-start w-full'
        : 'flex items-center'
    "
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["justifyB", "justifyC", "justifyD"],
};
</script>

<style></style>
